import React, { useState } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Plans from './Plans';
import FeatureCarousel from './FeatureCarousel';
import Login from './login'; 
import PlanWizard from './PlanWizard'; 
import Summary from './Summary';
import Payment from './Payment';
import Dashboard from './Dashboard';
import ActivePlan from './ActivePlan';
import History from './History';
import Profile from './Profile';
import NotFound from './NotFound';
import Feedback from './Feedback';
import AdminLogin from './Admin/Login';
import AdminDashboard from './Admin/Dashboard';
import AdminPlans from './Admin/Plans'
import AdminUsers from './Admin/Users'
import AdminFeedback from './Admin/Feedback';
import PlanDetails from './Admin/PlanDetails';
import Terms from './Terms';
import VideoReports from './Admin/VideoReports';
import VideoReportDetails from './Admin/VideoReportDetails';
import ContactUs from './ContactUs'
import PaymentResult from './PaymentResult';
import Faq from './Faq';
import ZibalTrustBadge from './component/ZibalTrustBadge';
import DiscountStrip from './component/DiscountStrip'; 
import DownloadApp from './DownloadApp';


export default function App() {
  const [dark, setDark] = useState(true);
const API_URL = process.env.REACT_APP_API_URL;

const handleFreePlanClick = () => {
  const token = localStorage.getItem('token');
        localStorage.setItem('freeRequestedPlan', 3);
        localStorage.setItem('freePlanType', 0);
        localStorage.setItem('freePrice', 0);

  const redirectState = {
    to: '/PlanWizard'
  };

  if (!token) {
    localStorage.setItem('redirectAfterLogin', JSON.stringify(redirectState));
    window.location.href = '/login';
    return;
  }

  window.location.href = '/PlanWizard';
};


return (
  <Router>
    <Routes>
      <Route path="/" element={
        <>
          {
                <div className={dark ? 'dark' : ''}>
      <div className="bg-white dark:bg-[#0e1015] text-black dark:text-white font-vazir min-h-screen transition-all duration-300">

{/* Discount Banner */}
    <DiscountStrip />




        {/* Toggle Theme Button */}
        {/* <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg flex items-center justify-center"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button> */}
        {/* Section 1: Header */}
        <header className="flex items-center justify-between px-6 py-4 shadow-md bg-white dark:bg-[#1a1d2e]">
          <div className="flex items-center gap-2">
            {/* <img src="/logo.png" alt="Mogym Logo" className="h-8" />
            <h1 className="text-xl font-bold">موجیم</h1> */}
          </div>
          <button 
            onClick={() => window.location.href = '/login'}
          className="bg-purple-600 hover:bg-purple-700 transition px-4 py-2 rounded-xl text-white">ورود / ثبت‌نام</button>
        </header>
                {/* Section 2: Hero Section */}
        <section className="text-center py-20 px-4 bg-gray-100 dark:bg-[#0e1015] transition-colors duration-300">
          <img src="/logo.png" alt="Mogym Logo" className="h-24 mx-auto mb-6" />
          <h2 className="text-3xl font-extrabold mb-4">باشگاهی به وسعت ایران</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-md mx-auto mb-6">
                            اولین اپلیکیشن فارسی تناسب اندام با هوش مصنوعی         
        </p>
          <button onClick={() => window.location.href='/plans'} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-xl text-lg">
            شروع برنامه
          </button>
        </section>
                {/* Section 3: Features */}
                <FeatureCarousel />

                {/* Section 4: Free Trial */}
        <section className="bg-gray-100 dark:bg-[#0e1015] py-16 px-6 text-center">
          <div className="max-w-xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">برنامه رایگان ۳ روزه</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              برای آشنایی با موجیم، یک برنامه کامل تمرین و تغذیه برای ۳ روز به صورت رایگان دریافت کن
            </p>
            <button onClick={() => handleFreePlanClick()} className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-xl text-lg">
              دریافت رایگان برنامه
            </button>
          </div>
        </section>
                {/* Section 5: Full Plan CTA */}
        <section className="bg-white dark:bg-[#1a1d2e] py-16 px-6 text-center">
          <div className="max-w-xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">می‌خوای حرفه‌ای‌تر برنامه بگیری؟</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              با دریافت برنامه کامل تمرین، رژیم، مکمل و تحلیل هوشمند، حرفه‌ای پیش برو
            </p>
            <button onClick={() => window.location.href='/plans'} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-xl text-lg">
              درخواست برنامه کامل
            </button>
          </div>
        </section>
                {/* Section 7: Footer */}
        <footer className="bg-gray-200 dark:bg-[#0e1015] py-8 text-center text-sm text-gray-600 dark:text-gray-400 border-t border-gray-300 dark:border-gray-700">
  <div className="flex justify-center gap-6 mb-4">
    <a href="/terms" className="hover:underline">شرایط و مقررات</a>
    <a href="/faq" className="hover:underline">سوالات متداول</a>
    <a href="/contact-us" className="hover:underline">ارتباط با ما</a>
  </div>
  <div className="flex justify-center gap-4">
    <a href="https://www.linkedin.com/company/mogym-ir/" target="_blank" rel="noopener noreferrer">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.27c-.966 0-1.75-.785-1.75-1.75s.784-1.75 1.75-1.75 1.75.785 1.75 1.75-.784 1.75-1.75 1.75zm13.5 11.27h-3v-5.604c0-1.337-.025-3.061-1.865-3.061-1.865 0-2.151 1.456-2.151 2.962v5.703h-3v-10h2.882v1.367h.042c.402-.762 1.384-1.565 2.848-1.565 3.045 0 3.608 2.005 3.608 4.614v5.584z"/>
      </svg>
    </a>
    <a href="https://www.instagram.com/mogym.ir?igsh=MTd1bHM4NXFwNWU4MA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.356 3.608 1.332.976.975 1.27 2.242 1.332 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.356 2.633-1.332 3.608-.975.976-2.242 1.27-3.608 1.332-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.356-3.608-1.332-.976-.975-1.27-2.242-1.332-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.356-2.633 1.332-3.608.975-.976 2.242-1.27 3.608-1.332 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-1.657.077-3.127.443-4.285 1.601-1.158 1.158-1.524 2.628-1.601 4.285-.058 1.28-.072 1.688-.072 4.947s.014 3.667.072 4.947c.077 1.657.443 3.127 1.601 4.285 1.158 1.158 2.628 1.524 4.285 1.601 1.28.058 1.688.072 4.947.072s3.667-.014 4.947-.072c1.657-.077 3.127-.443 4.285-1.601 1.158-1.158 1.524-2.628 1.601-4.285.058-1.28.072-1.688.072-4.947s-.014-3.667-.072-4.947c-.077-1.657-.443-3.127-1.601-4.285-1.158-1.158-2.628-1.524-4.285-1.601-1.28-.058-1.688-.072-4.947-.072zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z"/>
      </svg>
    </a>
  </div>

  <div className="flex justify-center gap-4 mt-3">
      <ZibalTrustBadge />
    </div>
</footer>
      </div>
    </div>
          }
        </>
      } />
      <Route path="/plans" element={<Plans />} />
        <Route path="/Login" element={<Login />} />
          <Route path="/PlanWizard" element={<PlanWizard />} />
          <Route path="/summary" element={<Summary />} />
<Route path="/payment" element={<Payment />} />
<Route path="/dashboard" element={<Dashboard />} />
<Route path="/active-plan" element={<ActivePlan />} />
<Route path="/history" element={<History />} />
<Route path="/profile" element={<Profile />} />
<Route path="/feedback" element={<Feedback />} />
<Route path="/admin/login" element={<AdminLogin />} />
<Route path="/admin/dashboard" element={<AdminDashboard />} />
<Route path="/admin/plans" element={<AdminPlans />} />
<Route path="/admin/users" element={<AdminUsers />} />
<Route path="/admin/feedback" element={<AdminFeedback />} />
<Route path="/admin/plan/:id" element={<PlanDetails />} />
<Route path="/terms" element={<Terms />} />
<Route path="/admin/videoReports" element={<VideoReports />} />
<Route path="/admin/reports/:id" element={<VideoReportDetails />} />
<Route path="/contact-us" element={<ContactUs />} />
<Route path="/payment-result" element={<PaymentResult />} />
<Route path="/faq" element={<Faq />} />
<Route path="/app" element={<DownloadApp />} />

<Route path="*" element={<NotFound />} />

    </Routes>
  </Router>
);
}
